import { PlatformLayout } from "./platform-layout";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { AuditContent } from "./platform-audit";
import { PiiScansContent } from "./platform-pii-scans";
import { HoneytokensContent } from "./platform-honeytokens";
import { DevicesContent } from "./platform-devices";
import { IpAllowlistContent } from "./platform-ip-allowlist";
import { SecretsContent } from "./platform-secrets";
import { AccountSecurityContent } from "./platform-account-security";
import { PlatformDocumentSecurityContent } from "./platform-document-security";
import {
  FileText,
  ScanLine,
  Fingerprint,
  Laptop,
  Shield,
  KeyRound,
  UserCog,
  FolderSearch,
} from "lucide-react";

export function SecurityHubContent() {
  return (
    <Tabs defaultValue="account">
      <TabsList className="flex flex-wrap h-auto gap-1 mb-4">
        <TabsTrigger value="account" data-testid="tab-security-account">
          <UserCog className="h-4 w-4 mr-1.5" />
          Account
        </TabsTrigger>
        <TabsTrigger value="audit" data-testid="tab-security-audit">
          <FileText className="h-4 w-4 mr-1.5" />
          Audit
        </TabsTrigger>
        <TabsTrigger value="pii-scans" data-testid="tab-security-pii">
          <ScanLine className="h-4 w-4 mr-1.5" />
          PII Scans
        </TabsTrigger>
        <TabsTrigger value="honeytokens" data-testid="tab-security-honeytokens">
          <Fingerprint className="h-4 w-4 mr-1.5" />
          Honeytokens
        </TabsTrigger>
        <TabsTrigger value="devices" data-testid="tab-security-devices">
          <Laptop className="h-4 w-4 mr-1.5" />
          Devices
        </TabsTrigger>
        <TabsTrigger value="ip-allowlist" data-testid="tab-security-ip">
          <Shield className="h-4 w-4 mr-1.5" />
          IP Allowlist
        </TabsTrigger>
        <TabsTrigger value="secrets" data-testid="tab-security-secrets">
          <KeyRound className="h-4 w-4 mr-1.5" />
          Secrets
        </TabsTrigger>
        <TabsTrigger value="documents" data-testid="tab-security-documents">
          <FolderSearch className="h-4 w-4 mr-1.5" />
          Documents
        </TabsTrigger>
      </TabsList>

      <TabsContent value="account">
        <AccountSecurityContent />
      </TabsContent>
      <TabsContent value="audit">
        <AuditContent />
      </TabsContent>
      <TabsContent value="pii-scans">
        <PiiScansContent />
      </TabsContent>
      <TabsContent value="honeytokens">
        <HoneytokensContent />
      </TabsContent>
      <TabsContent value="devices">
        <DevicesContent />
      </TabsContent>
      <TabsContent value="ip-allowlist">
        <IpAllowlistContent />
      </TabsContent>
      <TabsContent value="secrets">
        <SecretsContent />
      </TabsContent>
      <TabsContent value="documents">
        <PlatformDocumentSecurityContent />
      </TabsContent>
    </Tabs>
  );
}

export default function PlatformSecurityHub() {
  return (
    <PlatformLayout>
      <SecurityHubContent />
    </PlatformLayout>
  );
}
